import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {DataSetPref} from '../constants';

/** Is the user above the min user level? */
export const datamanagerAuthorized = () =>
	currentUserMeetsUserLevel(
		parseInt(getPreference(DataSetPref.MIN_USER_LEVEL) || '') ||
			UserLevel.MANAGER,
	);
